import { render, staticRenderFns } from "./servicePage.vue?vue&type=template&id=5a12b72a&scoped=true&"
import script from "./servicePage.vue?vue&type=script&lang=js&"
export * from "./servicePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a12b72a",
  null
  
)

export default component.exports